<template>
  <div class="tile-preview-container" :class="parentPathTypeClass">
    <div class="tile-promo-display-selections-div">
      <div
        v-if="
          ['web', 'android_os'].includes(model.device_type) ||
          (appsStore.app?.flags?.legacy_apple_editor && model.device_type === 'ios')
        "
        class="tile-promo-display-selections-opt"
      >
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'desktopViewTab' }"
          @click="$emit('clickTab', 'desktopViewTab')"
        >
          {{
            model.device_type === "android_os"
              ? "TV & Tablet"
              : model.device_type === "web"
                ? "Desktop"
                : "iPad"
          }}
        </button>
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'mobilewebViewTab' }"
          @click="$emit('clickTab', 'mobilewebViewTab')"
        >
          {{
            model.device_type === "android_os"
              ? "Phone"
              : model.device_type === "web"
                ? "Mobile Web"
                : "iPhone"
          }}
        </button>
      </div>
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <RfLanguagePreview :model="model" :actions="actions" />
      </div>
    </div>
    <v-tabs-window :modelValue="viewTypeTab" class="h-full w-full cursor-not-allowed">
      <v-window-item
        id="desktopViewTab"
        :transition="false"
        :reverseTransition="false"
        value="desktopViewTab"
        class="desktop-web-base-bg"
      >
        <RfRetentionBannerContent
          ref="rfmodal"
          :model="model"
          :actions="previewActions"
          deviceType="desktop"
          :hideButtons="['ios', 'android_os', 'tv_os'].includes(model.device_type)"
          :zoomStyle="zoomStyle"
          :zoomValue="zoomValue"
        />
      </v-window-item>
      <v-window-item
        id="mobilewebViewTab"
        :transition="false"
        :reverseTransition="false"
        value="mobilewebViewTab"
      >
        <RfWidgetMobileContent
          ref="rfwidgetMobile"
          :actions="previewActions"
          :model="model"
          :hideButtons="['ios', 'android_os', 'tv_os'].includes(model.device_type)"
        />
      </v-window-item>
    </v-tabs-window>
    <div v-if="viewTypeTab === 'desktopViewTab' && !isWidgetPromo" class="preview-control-buttons">
      <v-btn size="small" color="#f3f3f3" @click="zoomIn">+</v-btn>
      <v-btn class="reset-zoom-btn" size="small" color="#f3f3f3" @click="resetZoom">{{
        `${zoomValue * 100}%`
      }}</v-btn>
      <v-btn size="small" color="#f3f3f3" @click="zoomOut">-</v-btn>
    </div>
    <component :is="'style'" v-if="actions.rf_settings_custom_css">
      {{ actions.rf_settings_custom_css }}
    </component>
  </div>
</template>

<script>
import RfRetentionBannerContent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionBannerContent.vue";
import RfWidgetMobileContent from "@/components/RfPathCreate/RfRetentionActions/RfWidgetMobileContent.vue";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfLanguagePreview from "@/components/RfPathCreate/RfRetentionDevices/RfLanguagePreview.vue";
import ZoomPreviewMixin from "@/utils/ZoomPreviewMixin";
import CompositeImageSaver from "@/utils/CompositeImageSaver";
import { useAppsStore } from "@/pinia/appsStore";
import RfLiquidPreview from "./RfLiquidPreview.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionBanner",
  components: {
    RfRetentionBannerContent,
    RfWidgetMobileContent,
    RfLanguagePreview,
    RfLiquidPreview,
  },
  mixins: [ZoomPreviewMixin, LanguagePreviewMixin],
  props: ["actions", "viewTypeTab", "model", "actionGroupId"],
  setup: () => ({ appsStore: useAppsStore(), liquidContextStore: useLiquidContextStore() }),
  computed: {
    parentPathTypeClass() {
      return `${this.model.path_type}-editor-liveView editor-view-window`;
    },
    isWidgetPromo() {
      const pathType = this.model.path_type;
      return pathType === "widget";
    },
  },
  methods: {
    async fillModel(model) {
      if (!model.device_type) {
        model.device_type = this.model.device_type;
      }
      await CompositeImageSaver.fill(model, this.$refs, this.appsStore.app);
    },
  },
};
</script>
